import { Component, OnInit } from '@angular/core';
import * as moment from 'moment/moment';
import * as _ from 'lodash/lodash';
import { UserService } from '../../../common/services/user.service';
import { TechnicalserviceCompanyService } from '../../../configuration/services/technicalservice-company.service';

@Component({
  selector: 'app-list-user',
  templateUrl: './list-user.component.html',
  styleUrls: ['./list-user.component.css'],
  providers:[UserService,TechnicalserviceCompanyService]
})
export class ListUserComponent implements OnInit {
  p: number = 1;
  totalItems: number = 0;
  users: any = [];  
  technicalserviceCompanies: any = [];
  roles:any = [
    {name:"Admin", id:1},
    {name:"Usuario Interno", id:2},
    {name:"Usuario externo", id:3}
  ];

  constructor(private userService: UserService , private technicalserviceCompanyService: TechnicalserviceCompanyService) { }

  ngOnInit() {
    this.getUsers();
    this.getTechnicalserviceCompanies();
  }

  getTechnicalserviceCompanies(){
    this.technicalserviceCompanyService.query({}).subscribe((technicalserviceCompanies)=>{
      this.technicalserviceCompanies = technicalserviceCompanies;
    });
  }

  getUsers(){
    this.userService.query({})
               .subscribe((users) => {
                  this.users = users;
                });
  }

  getValue(array, id){
    return array.filter((e)=> {return e.id === id;})[0]?array.filter((e)=> {return e.id === id;})[0].name: "";
  }

}



// WEBPACK FOOTER //
// ./src/app/user/components/list-user/list-user.component.ts